import { TNewOrderCountry, TViewsKeyValue } from "@/entities/new-order";
import { getDatesListFromCountry } from "@/entities/new-order/utils";

export const getFirstCountryKeywordValue = (
  country: TNewOrderCountry,
  key: string,
): number => {
  const dates = getDatesListFromCountry(country);

  // Проверяем, что есть хотя бы одна дата
  if (dates.length === 0) {
    return 0;
  }

  const firstDate = dates[0];

  // Проверяем, что дата существует в keywords
  const firstDateKeywords = country.keywords[firstDate];
  if (!firstDateKeywords || Array.isArray(firstDateKeywords)) {
    return 0;
  }

  const keywordValue = (firstDateKeywords as Record<string, unknown>)[key];

  // Проверяем, что значение существует
  if (keywordValue === undefined || keywordValue === null) {
    return 0;
  }

  // Если это объект с installs (TViewsKeyword), возвращаем installs
  if (typeof keywordValue === "object" && keywordValue !== null) {
    return (keywordValue as TViewsKeyValue[string]).installs ?? 0;
  }

  // Иначе это обычное число (TBaseKeyword)
  return Number(keywordValue) || 0;
};
